import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { SaveFeedstockLoadScheduleRequest } from '../interfaces/feedstocklistmodel';
import { environment } from '../environments/environment';
import { GetLabDataCaptureBySiteIdResponse, LabDataCaptureSites, labDataCaptureSiteTanksDigestorsResponse } from '../interfaces/siteType';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { SaveLabDataCaptureRequest } from '../interfaces/labDataModel';

@Injectable({
  providedIn: 'root'
})
export class LabdataService{
    baseUrl = environment.baseUrl +'labdatacapture/';
    constructor(private http: HttpClient) { }

    getLabdataSites():Observable<LabDataCaptureSites[]> {
      var url = `${this.baseUrl}`;
      return this.http.get<LabDataCaptureSites[]>(url);
    }

    getLabDataTabs(siteId:string):Observable<labDataCaptureSiteTanksDigestorsResponse[]> {
      var url = `${this.baseUrl}GetLabDataCaptureSiteTanksDigestors?siteId=${siteId}`;
      return this.http.get<labDataCaptureSiteTanksDigestorsResponse[]>(url);
    }

    getLabDataCaptureData(siteId:string, fromDate: string | null, toDate: string | null):Observable<GetLabDataCaptureBySiteIdResponse[]> {
      var url = `${this.baseUrl}GetLabDataCaptureBySiteId?SiteId=${siteId}&FromDate=${fromDate}&ToDate=${toDate}`;
      // if(dateCapture === null){
      //   url = `${this.baseUrl}GetLabDataCaptureBySiteId?siteId=${siteId}`;
      // }
      return this.http.get<GetLabDataCaptureBySiteIdResponse[]>(url);
    }

    saveLoadData(payload: SaveLabDataCaptureRequest): Observable<boolean> {
      const saveApiUrl = this.baseUrl;
      return this.http.post<boolean>(saveApiUrl, payload);
    }

    deleteLabDataCaptureData(id: number): Observable<boolean> {
      const params = new HttpParams().set('id', id.toString());
      var url = `${this.baseUrl}DeleteLabDataCaptureBySiteId`;
      return this.http.delete<boolean>(`${url}`, { params: params });
    }

    
  
  atLeastOneFieldValidator(control: AbstractControl): { [key: string]: any } | null {
    const formArray = control.get('tanks') as FormArray;

    if (!formArray || !formArray.controls || formArray.controls.length === 0) {
      return null;
    }
    const hasValue = formArray.controls.some((group: AbstractControl) => {
      const formGroup = group as FormGroup;
      return Object.keys(formGroup.controls).some(key => {
        const value = formGroup.get(key)?.value;
        return value !== null && value !== undefined && value !== '';
      });
    });  
    return hasValue ? null : { atLeastOneRequired: true };
  }
}
